import { Directive, ElementRef, Input, OnChanges } from '@angular/core';
import ComponentUtils from '../component/component-utils';

@Directive({
  selector: '[appActiveItem]',
  standalone: false,
})
export class ActiveItemDirective implements OnChanges {
  @Input({ alias: 'appActiveItem', required: true }) active: boolean = false;
  constructor(
    private elementRef: ElementRef,
  ) {}

  ngOnChanges(): void {
    ComponentUtils.updateElement(this.elementRef, this.active);
  }
}
